import React, { Component } from 'react'
import { checkTranslation, setObject, translate } from "../../../utils/useful";
import FormViewer from '../../../components/FormViewer';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import SwitchInput from '../../../components/inputs/SwitchInput';
import ActionButton from '../../../components/partials/ActionButton';
import FixedView from '../../../components/FixedView';
import SearchUsersFixedView from '../../CreateApplet/SearchUsersFixedView';
import SearchGroupsFixedView from '../../CreateApplet/SearchGroupsFixedView';
import GlobalUserMultiInput from '../../../components/inputs/GlobalUserMultiInput';
import inputComponents from '../../../components/inputs/inputComponents';

class NewInqueryInfo extends Component {

    state = {
        public: true,
        searchTab: 'users',
        users: [],
        groups: [],
        headers: [
            { type: 'GlobalUserMultiInput', key: 'users', information: { label: '{{lang}}Add Users', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
        ]
    }

    componentDidMount() {
        // console.log('this.props.collectionId', this.props)
        // this.props.changeBackbtn(true)
        // console.log('this.props.editForm', this.props.editForm)
        if (this.props.editForm) {
            // console.log('newInquiryasdqqqqqqqqqq')
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                title: '{{lang}}Edit Inquiry',
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => {
                    this.props.changePage(this.props.collectionId);
                    this.props.setData2('editInquiry', false, 'CollectionView');
                    // console.log('backActionHappend');
                    this.props.defaultCollectionHeader()

                }
            })
        }
        else {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                title: '{{lang}}New Inquery',
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => {
                    this.props.changePage(this.props.collectionId);
                    this.props.setData2('newInquiry', false, 'CollectionView');
                    this.props.defaultCollectionHeader()
                }
            })
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    title='{{lang}}Next'
                    icon='/assets/icons/arrow-right-white.svg'
                    // icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }

    nextStage = (stage) => {
        // console.log('this.form',this.form)
        let rawData = this.form.getForm()
        // this.QiuzTime.getForm()
        let data = this.props.data ?? {}
        let duration = []
        if (rawData) {

            if (rawData.duration && rawData.duration.length > 0) {
                for (let i = 0; i <= 2; i++) {
                    if (rawData.duration[i]) {
                        if (Number(rawData.duration[i]) < 10) {
                            duration[i] = '0' + String(Number(rawData.duration[i]))
                        }
                        else {
                            duration[i] = (rawData.duration[i])
                        }
                    }
                    else {
                        duration[i] = '00'
                    }
                }
            }
            if (duration == ['00', '00', '00']) {
                duration = []
            }
            // return
            // console.log('rawData', rawData)
            // duration = (rawData.duration[0] * 3600) + (rawData.duration[1] * 60) + (rawData.duration[2])
            // setObject(data, 'values', rawData.values)

            // data.values.title = rawData.values.title
            // data.values.teacher = rawData.values.teacher
            // data.values.description = rawData.values.description
            // data.values.time = rawData.values.duration
            // data.values.duration = rawData.values.duration
            // // data.time = String((duration[0] * 3600) + (duration[1] * 60) + (duration[2] * 1))
            // data.values.date = rawData.values.date
            // data.values.expiryDate = rawData.values.expiryDate
            // data.values.public = rawData.values.public
            // data.values.participations = []
            // console.log('this.state.users', rawData)

            if (data.public) {
                setObject(data, 'values.userParticipants', null)
                setObject(data, 'values.groupParticipants', null)

            }
            // if (!data.public) {
            //     data.values.userParticipants = rawData.values.userParticipants
            //     data.values.groupParticipants = rawData.values.groupsParticipants
            // }
            // return
            console.log('rawData', rawData)
            this.props.setData( rawData, () => {
                // this.props.setData('headers', data, () => {
                    if( this.props.participation){

                    this.props.changeStage('userAnswerSheet')
                    }else{

                        this.props.changeStage('form')
                    }
                // })
            })
        }
    }

    setData = (key, value) => {
        this.setState({ [key]: value }, () => {
            let second = 0
        })
    }

    changeValue = (key, value) => {
        // console.log('changeValue')
        this.setState({ [key]: value }, () => {
            // if (this.state.public) {
            //     this.setState({ publicPermissions: '*' })
            // }
        })
    }

    changeUsers = (key, value, extra) => {
        let users = [...this.state.users]
        users = value
        this.setState({ users })

    }

    setSearchTab = (tab) => {
        this.setState({ searchTab: tab })
    }

    // changeValue = () => {
    // }
    setFormData = (key, value, cb) => {
        // console.log('key,value,cb', key, value, cb)

    }
    render() {
        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let hub = this.props.initData?.hub
        variables.hub = hub
        variables.targetId = hub
        let searchTab = this.state.searchTab
// console.log('ddress, filte111',variables);
        return (
            <div className='w-100 h-100'>
                <div className='pt-4 flexc flex-column px-4 h-100 scroll-no-scrollbar' style={{ backgroundColor: '#f0f0f0' }}>
                    <div className='br-20 mb-5 pb-4' style={{ backgroundColor: '#fff', maxWidth: 800 }}>
                        <div className=" w-100 " style={{}}>
                            <div className='flexc w-100 '>
                                <div className='px-5 pt-4 w-100 flexcc flex-column'>
                                    <div className='w-100'>
                                        <div className='flexc'>
                                            <p className="text-semibig text-semibold" >{translate('Inquiry information')}</p>
                                        </div>
                                        <div className='mt-3 ' >
                                           
                                            <FormViewer variables={variables} ref={el => this.form = el} initData={this.props.data} data={this.props.data} headers={this.props.headers} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.setFormData} />
                                        </div>
                                        {/* <div className='flexcb mt-1'>
                                            <p className='color-dark-blue-1 text-small text-semibold' >{translate('ca.Public')}</p>
                                            <SwitchInput data={this.state.public} header={{ key: 'public', information: { className: "slider2" } }} changeValue={this.changeValue} />
                                        </div>
                                        {this.state.public ? (
                                            <div className='pt-2 pb-3' style={{}}>
                                                <p className='text-small color-dark-blue-1 opacity-5'>{translate('This inquiry will be accessable for the all users and groups.')}</p>
                                            </div>
                                        ) : (
                                            <>
                                                <div className='pt-2 pb-3' style={{}}>
                                                    <p className='text-small color-dark-blue-1 opacity-5'>{translate('This inquiry will be accessable for the users and groups which are added in the above List. Other users can not have access to or see this inquiry.')}</p>
                                                </div>
                                                {this.state.headers && this.state.headers.map((header, index) => {
                                                    let Component = inputComponents[header.type]
                                                    return (
                                                        <div key={index} style={{ display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#f4f4f4', minHeight: '38px', padding: '8px 10px', borderRadius: '6px', fontSize: '14px', transition: 'all 0.3s', outline: 'none' }}>
                                                            <Component header={header} data={this.state.users} changeValue={this.changeUsers} />
                                                        </div>
                                                    )
                                                })}
                                            </>
                                        )} */}
                                        {/* // <div style={{ display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#f4f4f4', minHeight: '38px', padding: '8px 10px', borderRadius: '6px', fontSize: '14px', transition: 'all 0.3s', outline: 'none' }}>
                                        //     <GlobalUserMultiInput data={this.state.users} changeValue={this.changeUsers} header={{ key: 'users', information: { label: '{{lang}}Add Users', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } }} />
                                        // </div> */}
                                        {/* <div className='mld-1'>
                                    <QiuzTime ref={el => this.QiuzTime = el} setData={this.setData} setData2={this.props.setData} data={this.props.data} />
                                </div> */}
                                        {/* <div className='mt-3 mb-5 mx-3'>
                                        <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={'linear-gradient(90deg, #6E9318, #96C723)'} title={'Next'} onClick={() => this.nextStage()} />
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewInqueryInfo;